import { render, staticRenderFns } from "./RequisitionCard.vue?vue&type=template&id=69581c41&scoped=true"
import script from "./RequisitionCard.vue?vue&type=script&lang=js"
export * from "./RequisitionCard.vue?vue&type=script&lang=js"
import style0 from "./RequisitionCard.vue?vue&type=style&index=0&id=69581c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69581c41",
  null
  
)

export default component.exports